import * as React from 'react';
import { Control, Errors, LocalForm } from 'react-redux-form';
import ReactDatePicker from 'react-datepicker';
import { hasDateValue, getDefaultErrorMessages } from '@common/validators';
import * as moment from 'moment-timezone';
import { dateParser } from '@common/dateParser';

interface ExtendCOEModalComponentProperties {
  readonly saveCallback: (date: string) => void;
  readonly buttonRef: (button: HTMLButtonElement) => void;
}

export class ExtendCOEModalComponent extends React.Component<ExtendCOEModalComponentProperties> {
  handleSubmit = (formData: any) => {
    this.props.saveCallback(formData.newDate);
  };

  render() {
    return (
      <>
        <LocalForm model="extendCOEForm" hideNativeErrors={true} onSubmit={this.handleSubmit}>
          <div className="form-control col-md-12">
            <label htmlFor="extendCOEForm.cancelDate">New Date</label>
            <Control
              model=".newDate"
              validators={{ hasDateValue: hasDateValue }}
              validateOn="blur"
              component={props => {
                let val;
                if (props.value && !moment.isMoment(props.value)) {
                  val = dateParser.parse(props.value);
                } else {
                  // already a moment
                  val = props.value;
                }

                return (
                  <ReactDatePicker {...props} value={val ? val.format('MM/DD/YYYY') : ''} selected={val || null} />
                );
              }}
            />
            <Errors
              className="error"
              model=".cancelDate"
              show={{ touched: true, focus: false }}
              messages={{ ...getDefaultErrorMessages(), validDate: 'Invalid Date' }}
            />
          </div>
          <div className="col-md-12">
            <div className="row end-xs">
              <button className="btn btn-hidden" type="submit" ref={this.props.buttonRef}>
                Save
              </button>
            </div>
          </div>
        </LocalForm>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/contract/_components/extend-coe/extend-coe.component.tsx